import { render } from "./CurriculumAdmin.vue?vue&type=template&id=73c6fa52&scoped=true"
import script from "./CurriculumAdmin.vue?vue&type=script&lang=js"
export * from "./CurriculumAdmin.vue?vue&type=script&lang=js"

import "./CurriculumAdmin.vue?vue&type=style&index=0&id=73c6fa52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c6fa52"]])

export default __exports__